import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { take, switchMap, map } from 'rxjs';
import { OrgWorkflowService } from '@core/services/org-workflow/org-workflow.service';
import { AuthService } from '@core/auth/services/auth.service';
import { environment } from '@env/environment';

export const doorwayAuthGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const orgWorkflowService = inject(OrgWorkflowService);
  const router = inject(Router);
  const authUrl = environment.authUrl;

  return authService.isAuthenticated$.pipe(
    take(1),
    switchMap((isAuthenticated) => {
      if (!isAuthenticated) {
        const returnUrl = encodeURIComponent(window.location.origin + state.url);
        window.location.href = `${authUrl}forward?app=${environment.medeaseAppId}&returnUrl=${returnUrl}`;
        return [false];
      }

      return orgWorkflowService.baseOrg$.pipe(
        take(1),
        map((baseOrg) => {
          const baseOrgType = baseOrg?.type || baseOrg?.orgType;
          if (baseOrgType === 'root') {
            return true;
          }

          router.navigate(['/dashboard']);
          return false;
        })
      );
    })
  );
};
